module.exports = __webpack_public_path__ + "img/bg.f6a2f70e.png";